export const transformPhotoTipDto = photoTip => {
  const {
    id,
    title,
    body,
    entry_type,
    sorting_order,
    image_url
  } = photoTip;
  return {
    id,
    title,
    body,
    entryType: entry_type,
    sortingOrder: sorting_order,
    imageUrl: image_url
  };
};
export const transformPhotoTipDtos = photoTips => photoTips.map(transformPhotoTipDto);